export default {
    PIX: 'PIX',
    DINHEIRO: 'Dinheiro',
    BOLETO: 'Boleto',
    CHEQUE: 'Cheque',
    DEPOSITO: 'Deposito',
    TED: 'TED',
    CARTAO_DEBITO: 'Cartão de Débito',
    CARTAO_CREDITO: 'Cartão de Crédito',
}
